import React, { useState } from 'react';
import { Select, Typography, Row, Col, Avatar, Card, Alert } from "antd";
import moment from 'moment';
import Loader from './Loader';

import { useGetCryptoNewsQuery } from '../services/cryptoNewsApi';
import { useGetCryptosQuery } from '../services/cryptoApi';

const { Text, Title } = Typography;

const demoImage = 'http://coinrevolution.com/wp-content/uploads/2020/06/cryptonews.jpg';

const News = ({ simplified }) => {
  const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
  const { data: cryptoNews, isError: isNewsError } = useGetCryptoNewsQuery({ newsCategory, count: simplified ? 6 : 12 })
  const { data } = useGetCryptosQuery(100, {
    skip: simplified // Skip fetching cryptos list when in simplified mode
  });

  if (!cryptoNews?.value) return <Loader />;

  if (isNewsError) {
    return (
      <Alert
        message="Unable to Load News"
        description="News service is temporarily unavailable. Please check back later."
        type="info"
        showIcon
        style={{ margin: '20px' }}
      />
    );
  }

  // Create options array for Ant Design 5
  const selectOptions = [
    { value: 'Cryptocurrency', label: 'Cryptocurrency' },
    ...(data?.data?.coins?.map((coin) => ({ value: coin.name, label: coin.name })) || [])
  ];

  return (
    <Row gutter={[24, 24]}>
      {!simplified && (
        <Col span={24}>
          <Select
            showSearch
            className='select-news'
            placeholder="Select a Crypto"
            optionFilterProp="label"
            onChange={(value) => setNewsCategory(value)}
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            options={selectOptions}
          />
        </Col>
      )}
      {cryptoNews.value.map((news, i) => (
        <Col xs={24} sm={12} lg={8} key={i}>
          <Card hoverable className="news-card">
            <a href={news.url} target="_blank" rel="noreferrer">
              <div className="news-image-container">
                <Title className='news-title' level={4}>{news.name}</Title>
                <img style={{ maxWidth: '200px', maxHeight: '100px' }} src={news?.image?.thumbnail?.contentUrl || demoImage} alt="news" />
              </div>
              <p>
                {news.description?.length > 100
                  ? `${news.description.substring(0, 100)} ...`
                  : news.description
                }
              </p>
              <div className="provider-container">
                <div>
                  <Avatar src={news.provider[0]?.image?.thumbnail?.contentUrl || demoImage} alt="" />
                  <Text className="provider-name">{news.provider[0]?.name}</Text>
                </div>
                <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
              </div>
            </a>

          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default News